
































































import Vue, { PropType } from 'vue';
import { PeerGroupMember } from '@/models/orgStructure';
import { BasePeerGroup, MemberRole } from '@/models';
import * as Utils from '@/utils';

import OrganizationUserCard from '@/components/OrganizationUserCard.vue';
import OrganizationUserSlug from '@/components/OrganizationUserSlug.vue';
import PersistableItem from '@/components/PersistableItem.vue';
import PeerGroupRoleSelectorPills from '@/components/PeerGroupRoleSelectorPills.vue';
export default Vue.extend({
  components: {
    OrganizationUserCard,
    OrganizationUserSlug,
    PersistableItem,
    PeerGroupRoleSelectorPills
  },

  props: {
    member: {
      type: Object as PropType<PeerGroupMember>,
      required: true
    },
    peerGroup: {
      type: Object as PropType<BasePeerGroup>,
      required: true
    },
    status: Number // Well, an enum
  },

  data() {
    return {
      role: this.member.role,
      showLockMessage: false
    };
  },

  computed: {
    isDirty(): boolean {
      return this.role !== this.member.role;
    },
    saveDisabled(): boolean {
      return !this.isDirty;
    },
    dirtyMember(): PeerGroupMember {
      return {
        ...this.member,
        role: this.role
      };
    }
  },

  methods: {
    handleRoleChange(role: MemberRole) {
      this.role = role;
    },

    userClick() {
      const orgId = this.$route.params['organizationId'] as string;

      this.$router.push({
        name: 'OrganizationUser',
        params: { organizationId: orgId, userId: `${this.member.userId}` }
      });
    },

    async lockIconClicked() {
      this.showLockMessage = true;

      await Utils.sleep(4000);

      this.showLockMessage = false;
    }
  }
});
